import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

const FAQSection = ({ faqs, heading = 'Common Questions', dark = false }) => (
  <div data-testid="faq-section">
    {heading && (
      <h2 className={`font-serif text-3xl font-medium tracking-tight md:text-4xl ${dark ? 'text-paper' : 'text-ink'}`}>{heading}</h2>
    )}
    <Accordion type="single" collapsible className={`mt-8 ${dark ? 'text-paper' : 'text-ink'}`}>
      {faqs.map((f, i) => (
        <AccordionItem key={i} value={`faq-${i}`} className={dark ? 'border-paper/15' : 'border-line'}>
          <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-5 text-left font-serif text-lg hover:no-underline md:text-xl">
            {f.q}
          </AccordionTrigger>
          <AccordionContent data-testid={`faq-content-${i}`} className={`text-base leading-relaxed ${dark ? 'text-paper/70' : 'text-muted2'}`}>
            {f.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </div>
);

export default FAQSection;
